import { Link } from '@tanstack/react-router';
import { Button } from 'primereact/button';
import { BasicPage } from '~/components/ui/layout/page/basic/BasicPage';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';

const DEFAULT_MESSAGE = "Oops! The page you're looking for doesn't exist.";

type NotFoundPageProps = {
  message?: string;
};

export const NotFoundPage = ({
  message = DEFAULT_MESSAGE,
}: NotFoundPageProps) => (
  <BasicPage title="">
    <HeaderContainer>
      <Breadcrumb items={[{ name: '' }]} />
    </HeaderContainer>
    <div
      className="flex flex-column align-items-center justify-content-center"
      style={{ minHeight: 'calc(100vh - 4rem)' }}
    >
      <div className="text-center">
        <h1 className="text-8xl font-bold mb-4">404</h1>
        <p className="text-xl mb-6">{message}</p>
        <Link to="/">
          <Button label="Go Home" className="p-button-primary" />
        </Link>
      </div>
    </div>
  </BasicPage>
);
